import { DeleteAtom } from './DeleteAtom'

export default DeleteAtom
